import cssHasPseudo from 'css-has-pseudo/browser'

export const loadCssHasPseudoLib = () => {
  if (typeof document !== 'undefined' && typeof cssHasPseudo === 'function') {
    cssHasPseudo(document)
  }
}
